import { Link } from "@inertiajs/react";

const DEFAULT_DESCRIPTION =
  null;

type HouseCardProps = {
  name: string;
  communeName: string | null;
  description: string | null;
  image: string | null;
  fallbackImage: string;
  href: string;
};

/** Carousel item for the landing page's "casas" section. */
export default function HouseCard({
  name,
  communeName,
  description,
  image,
  fallbackImage,
  href,
}: HouseCardProps) {
  return (
    <Link
      href={href}
      className="block w-56 shrink-0 snap-start overflow-hidden rounded-3xl border border-ink/20 bg-white shadow-sm transition-shadow hover:shadow-md sm:w-64"
    >
      <img
        src={image ?? fallbackImage}
        alt={name}
        className="aspect-square w-full object-cover"
      />
      <div className="p-4">
        <h3 className="font-sans text-lg font-semibold text-ink">{name}</h3>
        {communeName && (
          <p className="mt-1 flex items-center gap-1 font-display text-sm font-light text-ink/80">
            <PinIcon className="h-4 w-4 shrink-0" />
            {communeName}
          </p>
        )}
        <p className="mt-1 text-justify font-display text-xs font-light leading-relaxed text-ink/80">
          {description || DEFAULT_DESCRIPTION}
        </p>
      </div>
    </Link>
  );
}

function PinIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      aria-hidden="true"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
      />
    </svg>
  );
}
